(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pzz-collection-banner"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pzz-collection-banner')) {
  class PzzCollectionBanner extends HTMLElement {
    connectedCallback() {
      this.desc  = this.querySelector('.pzz-cb__desc');
      this.btn   = this.querySelector('.pzz-cb__toggle');
      this.label = this.querySelector('.pzz-cb__toggle-label');
      if (!this.desc || !this.btn) return;

      this._onClick = this._onClick.bind(this);
      this.btn.addEventListener('click', this._onClick);

      this._evaluate();
      if ('ResizeObserver' in window) {
        this._ro = new ResizeObserver(() => {
          if (!this.classList.contains('is-expanded')) this._evaluate();
        });
        this._ro.observe(this.desc);
      }
    }

    disconnectedCallback() {
      if (this.btn) this.btn.removeEventListener('click', this._onClick);
      if (this._ro) this._ro.disconnect();
    }

    _evaluate() {
      // Only meaningful while collapsed (clamp active). Drives the is-truncated
      // class so the inline "Read more" shows only when there's more to reveal.
      const overflowing = (this.desc.scrollHeight - this.desc.clientHeight) > 4;
      this.classList.toggle('is-truncated', overflowing);
    }

    _onClick() {
      const expanded = this.classList.toggle('is-expanded');
      this.btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (this.label) {
        this.label.textContent = expanded
          ? (this.dataset.less || 'Read less')
          : (this.dataset.more || 'Read more');
      }
    }
  }
  customElements.define('pzz-collection-banner', PzzCollectionBanner);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pzz-main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pzz-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var CARD_SECTION = 'pzz-rv-card';

    function showPlaceholder(root, grid) {
      if (!(window.Shopify && Shopify.designMode)) return false;
      var msg = document.createElement('p');
      msg.className = 'custom-recently-viewed__placeholder';
      msg.textContent = 'Recently viewed products appear here once customers browse the store. (Shown in the editor only.)';
      grid.appendChild(msg);
      root.hidden = false;
      return true;
    }

    function init(root) {
      if (root.dataset.rvInit === '1') return;
      root.dataset.rvInit = '1';

      var grid = root.querySelector('[data-recently-viewed-grid]');
      if (!grid) return;

      var count = parseInt(root.dataset.count, 10) || 5;
      var current = root.dataset.currentHandle || '';

      // Read from the shared store (pzz-recently-viewed-products.js).
      var store = window.PZZRecentlyViewed;
      var list = store ? store.get() : [];

      var handles = list.filter(function (h) { return h && h !== current; }).slice(0, count);
      if (!handles.length) { showPlaceholder(root, grid); return; }

      // Fetch the native card section per handle (order preserved).
      Promise.all(handles.map(function (h) {
        return fetch('/products/' + encodeURIComponent(h) + '?section_id=' + CARD_SECTION, {
          headers: { Accept: 'text/html' }
        })
          .then(function (r) { return r.ok ? r.text() : Promise.reject(h); })
          .then(function (html) { return { handle: h, html: html }; })
          .catch(function () { return { handle: h, failed: true }; });
      })).then(function (results) {
        var dead = [];
        var rendered = 0;

        results.forEach(function (res) {
          if (res.failed) { dead.push(res.handle); return; }
          var html = (res.html || '').trim();
          // A deleted/unavailable handle can return an empty / card-less section.
          if (!html || html.indexOf('product-card') === -1) { dead.push(res.handle); return; }
          // The Section Rendering API wraps output in <div id="shopify-section-…">.
          // Transplant the wrapper's children only — never the shopify-section wrapper
          // itself, or it nests sections and the theme editor flags "Broken HTML".
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var wrapper = doc.getElementById('shopify-section-' + CARD_SECTION) || doc.querySelector('.shopify-section');
          var cell = document.createElement('div');
          cell.className = 'custom-recently-viewed__cell';
          if (wrapper) {
            while (wrapper.firstChild) { cell.appendChild(wrapper.firstChild); }
          } else {
            cell.innerHTML = html; // defensive fallback; shouldn't trigger
          }
          grid.appendChild(cell);
          rendered++;
        });

        // Prune handles that no longer resolve, via the shared store.
        if (dead.length && store) { store.remove(dead); }

        if (rendered) { root.hidden = false; }
        else { showPlaceholder(root, grid); }
      });
    }

    function run() {
      document.querySelectorAll('[data-recently-viewed]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }
    document.addEventListener('shopify:section:load', run);
  })();

  } catch(e) { console.error(e); }
})();
})();
